import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
import {faUserFriends} from '@fortawesome/free-solid-svg-icons'

class Footer extends Component{

    render(){
        return(
            <div className = "footerContainer">
                <div className = "grid">
                    <div className = "footerPanel">
                        <div className = "footerLeft">
                            &copy; 2020. Movie Bloggers Network. Powered by Sociacracy
                        </div>
                        <div className = "footerRight">
                            <ul className = "footerSocialIcons"> 
                                <li>
                                    <a href="#">
                                        <FontAwesomeIcon icon = {faFacebook}/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <FontAwesomeIcon icon = {faTwitter}/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <FontAwesomeIcon icon = {faUserFriends} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                   
                </div>
              
            </div>
            
        )
    }

}

export default Footer